"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProofOfFundsStatus = exports.ProofOfFundsRefundStatus = exports.VerificationProvider = exports.PersonVerificationError = exports.DocumentCategory = exports.KycCheckType = void 0;
var KycCheckType;
(function (KycCheckType) {
    KycCheckType["EKYC_CHECK"] = "EkycCheck";
    KycCheckType["PEP_CHECK"] = "PepCheck";
    KycCheckType["SIS_CHECK"] = "SisCheck";
    KycCheckType["IDV_CHECK"] = "IdvCheck";
    KycCheckType["PERSON_VERIFICATION"] = "PersonVerification";
})(KycCheckType = exports.KycCheckType || (exports.KycCheckType = {}));
var DocumentCategory;
(function (DocumentCategory) {
    DocumentCategory["PROOF_OF_ADDRESS"] = "PROOF_OF_ADDRESS";
    DocumentCategory["PROOF_OF_ID"] = "PROOF_OF_ID";
    DocumentCategory["COMPANY_REGISTRATION_CERTIFICATE"] = "COMPANY_REGISTRATION_CERTIFICATE";
    DocumentCategory["FINANCIAL_STATEMENT"] = "FINANCIAL_STATEMENT";
    DocumentCategory["OWNERSHIP"] = "OWNERSHIP";
    DocumentCategory["PROOF_OF_BUSINESS"] = "PROOF_OF_BUSINESS";
    DocumentCategory["SOURCE_OF_FUNDS"] = "SOURCE_OF_FUNDS";
    DocumentCategory["ARTICLES_OF_ASSOCIATION"] = "ARTICLES_OF_ASSOCIATION";
    DocumentCategory["PROOF_OF_DIRECTORS"] = "PROOF_OF_DIRECTORS";
    DocumentCategory["OTHER"] = "OTHER";
})(DocumentCategory = exports.DocumentCategory || (exports.DocumentCategory = {}));
var PersonVerificationError;
(function (PersonVerificationError) {
    // For example being born in 2025, or gender "Martian".
    PersonVerificationError["DATA_VALIDATION_FAILED"] = "DATA_VALIDATION_FAILED";
    // For example visual (non-textual) elements are incorrect given the document type.
    PersonVerificationError["DOCUMENT_VALIDATION_FAILED"] = "DOCUMENT_VALIDATION_FAILED";
    // For example submitting an expired passport.
    PersonVerificationError["DOCUMENT_EXPIRED"] = "DOCUMENT_EXPIRED";
    // For example a photo of a document or a photo of a computer screen.
    PersonVerificationError["ORIGINAL_DOCUMENT_ABSENT"] = "ORIGINAL_DOCUMENT_ABSENT";
    PersonVerificationError["DOCUMENT_TYPE_NOT_SUPPORTED"] = "DOCUMENT_TYPE_NOT_SUPPORTED";
    // For example blurry photo.
    PersonVerificationError["IMAGE_QUALITY_INSUFFICIENT"] = "IMAGE_QUALITY_INSUFFICIENT";
    PersonVerificationError["FACIAL_SIMILARITY_INSUFFICIENT"] = "FACIAL_SIMILARITY_INSUFFICIENT";
    // For example submitting a document that has been identified as lost, stolen or otherwise compromised.
    PersonVerificationError["GENERIC_ERROR_NO_RETRY"] = "GENERIC_ERROR_NO_RETRY";
    // NemID generic failure.
    PersonVerificationError["NEM_ID_ERROR"] = "NEM_ID_ERROR";
    // NemID server error.
    PersonVerificationError["NEM_ID_SERVER_ERROR"] = "NEM_ID_SERVER_ERROR";
    // Generic authentication error.
    PersonVerificationError["GENERIC_PROVIDER_ERROR"] = "GENERIC_PROVIDER_ERROR";
})(PersonVerificationError = exports.PersonVerificationError || (exports.PersonVerificationError = {}));
var VerificationProvider;
(function (VerificationProvider) {
    VerificationProvider["BANK_ID"] = "BANK_ID";
    VerificationProvider["SE_BANK_ID"] = "SE_BANK_ID";
    VerificationProvider["NO_BANK_ID"] = "NO_BANK_ID";
    VerificationProvider["NEM_ID"] = "NEM_ID";
    VerificationProvider["ONFIDO"] = "ONFIDO";
    VerificationProvider["TUPAS"] = "TUPAS";
    VerificationProvider["MIT_ID"] = "MIT_ID";
    VerificationProvider["IDIN"] = "IDIN";
    VerificationProvider["ITS_ME"] = "ITS_ME";
})(VerificationProvider = exports.VerificationProvider || (exports.VerificationProvider = {}));
var ProofOfFundsRefundStatus;
(function (ProofOfFundsRefundStatus) {
    ProofOfFundsRefundStatus["INITIATING"] = "INITIATING";
    ProofOfFundsRefundStatus["INITIATED"] = "INITIATED";
    ProofOfFundsRefundStatus["RECEIVED"] = "RECEIVED";
    ProofOfFundsRefundStatus["FAILED"] = "FAILED";
})(ProofOfFundsRefundStatus = exports.ProofOfFundsRefundStatus || (exports.ProofOfFundsRefundStatus = {}));
var ProofOfFundsStatus;
(function (ProofOfFundsStatus) {
    ProofOfFundsStatus["PENDING"] = "PENDING";
    ProofOfFundsStatus["INVESTIGATING"] = "INVESTIGATING";
    ProofOfFundsStatus["APPROVED"] = "APPROVED";
    ProofOfFundsStatus["REJECTED"] = "REJECTED";
    ProofOfFundsStatus["REJECTED_REFUND"] = "REJECTED_REFUND";
    ProofOfFundsStatus["PRE_APPROVED"] = "PRE_APPROVED";
    ProofOfFundsStatus["PRE_APPROVED_LEGAL_NAME_CHECK"] = "PRE_APPROVED_LEGAL_NAME_CHECK";
    ProofOfFundsStatus["PRE_APPROVED_ACRONYM_CHECK"] = "PRE_APPROVED_ACRONYM_CHECK";
    ProofOfFundsStatus["PRE_APPROVED_WORD_BY_WORD_CHECK"] = "PRE_APPROVED_WORD_BY_WORD_CHECK";
})(ProofOfFundsStatus = exports.ProofOfFundsStatus || (exports.ProofOfFundsStatus = {}));
//# sourceMappingURL=styx.js.map